var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-item"},[_c('order-item-header',{attrs:{"order-item":_vm.orderItem}}),_c('order-item-applicants',{attrs:{"applicant-list":_vm.orderItem.applicant_set}}),_c('order-item-btn-list',{attrs:{"order-item":_vm.orderItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }